import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'

export interface ActorListItem {
  id: string
  name: string
  role: 'staff' | 'manager' | 'admin'
}

async function fetchActorList(): Promise<ActorListItem[]> {
  const [cashierResult, adminResult] = await Promise.all([
    supabase.from('cashier_pins').select('id, name, role').order('name', { ascending: true }),
    supabase.from('admin_accounts').select('id, name').order('name', { ascending: true }),
  ])

  if (cashierResult.error) throw cashierResult.error
  if (adminResult.error) throw adminResult.error

  const actors: ActorListItem[] = [
    ...(cashierResult.data ?? []).map((c) => ({
      id: c.id,
      name: c.name,
      role: c.role as 'staff' | 'manager',
    })),
    ...(adminResult.data ?? []).map((a) => ({
      id: a.id,
      name: a.name,
      role: 'admin' as const,
    })),
  ]

  return actors.sort((a, b) => a.name.localeCompare(b.name))
}

export function useActorList() {
  return useQuery({
    queryKey: ['actor-list'],
    queryFn: fetchActorList,
    staleTime: 5 * 60 * 1000,
  })
}